export default __webpack_public_path__ + "static/media/screen-recorder-bestimg-test.png";